import React from "react";
import { Link } from "react-router-dom";
import nhsLogo from "../assets/nhs-logo.png";
import { formatMaintenanceMessage } from "../utils/maintenance";

export default function Maintenance({ message }) {
  return (
    <div className="pguh-maintenance-lock">
      <header className="pguh-maintenance-lock__header">
        <div className="nhsuk-width-container pguh-maintenance-lock__header-inner">
          <img src={nhsLogo} alt="NHS" className="pguh-maintenance-lock__logo" />
          <div>
            <strong>Royal University Hospitals Trust</strong>
            <span>Online services</span>
          </div>
        </div>
      </header>

      <main id="main-content" className="nhsuk-width-container pguh-maintenance-lock__main">
        <div className="pguh-maintenance-lock__panel">
          <span className="pguh-maintenance-lock__status">Planned maintenance</span>
          <h1 className="nhsuk-heading-xl">Service temporarily unavailable</h1>
          <p className="nhsuk-body-l">{formatMaintenanceMessage(message)}</p>

          <div className="pguh-maintenance-lock__info">
            <h2 className="nhsuk-heading-m">What you need to know</h2>
            <p className="nhsuk-body-m">
              The website, patient portal and staff intranet are temporarily unavailable while maintenance is in progress.
            </p>
            <p className="nhsuk-body-m">
              Refresh this page later. Access will return automatically once maintenance mode is switched off.
            </p>
          </div>

          <details className="nhsuk-details pguh-maintenance-lock__admin">
            <summary className="nhsuk-details__summary">
              <span className="nhsuk-details__summary-text">Management access</span>
            </summary>
            <div className="nhsuk-details__text">
              <p>Management accounts can sign in to bypass maintenance mode and continue using the intranet.</p>
              <Link className="nhsuk-button nhsuk-button--secondary" to="/login?maintenance=1">
                Administrator sign in
              </Link>
            </div>
          </details>
        </div>
      </main>
    </div>
  );
}
